// assets/header-hover.js
(function () {
  const DESKTOP_MIN_WIDTH = 990;
  const CLOSE_DELAY = 160; // 鼠标离开后短延迟避免闪烁
  const NESTED_CLOSE_DELAY = 120;

  function isDesktopHover() {
    return window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`).matches &&
           window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function init() {
    // 找到 header（优先使用 data-desktop-menu-type 的元素）
    const header = document.querySelector('[data-desktop-menu-type]') || document.querySelector('.header');
    if (!header) return;

    const menuType = (header.dataset.desktopMenuType || '').trim(); // e.g. "dropdown" or "mega"
    const hoverEnabled = (header.dataset.hoverDropdown || 'false') === 'true';

    if ((menuType !== 'dropdown' && menuType !== 'mega') || !hoverEnabled) return;

    if (!isDesktopHover()) return;

    // 标记页面已启用 JS（你的 mega css 使用 .js 选择器）
    document.documentElement.classList.add('js');

    // 导航容器
    const nav = header.querySelector('.header__inline-menu') || header.querySelector('nav.header__inline-menu');
    if (!nav) return;

    // 选择所有 <details>（包括一级和嵌套）——我们稍后区分父子
    const allDetails = Array.from(nav.querySelectorAll('details'));

    // 记录 timers
    const timers = new WeakMap();

    function openDetails(d) {
      try {
        d.open = true;
        const s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      } catch (e) { /* ignore */ }
    }

    function closeDetails(d) {
      try {
        d.open = false;
        const s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      } catch (e) { /* ignore */ }
    }

    function clearTimer(d) {
      const t = timers.get(d);
      if (t) {
        clearTimeout(t);
        timers.delete(d);
      }
    }

    function scheduleClose(d, delay = CLOSE_DELAY) {
      clearTimer(d);
      const t = setTimeout(() => {
        // 只有当鼠标与焦点都不在 details 内才关闭
        if (!d.matches(':hover') && !d.contains(document.activeElement)) closeDetails(d);
        timers.delete(d);
      }, delay);
      timers.set(d, t);
    }

    // Attach handlers to each details element
    allDetails.forEach((d) => {
      // For better pointer target use the nearest li if available
      const li = d.closest('li') || d;

      // mouse enter -> open immediately
      li.addEventListener('mouseenter', () => {
        if (!isDesktopHover()) return;
        clearTimer(d);
        openDetails(d);
      }, { passive: true });

      // mouse leave -> schedule close
      li.addEventListener('mouseleave', () => {
        if (!isDesktopHover()) return;
        scheduleClose(d, d.closest('details') ? NESTED_CLOSE_DELAY : CLOSE_DELAY);
      }, { passive: true });

      // keyboard: focusin inside -> open; focusout -> maybe close
      li.addEventListener('focusin', () => {
        if (!isDesktopHover()) return;
        clearTimer(d);
        openDetails(d);
      });

      li.addEventListener('focusout', () => {
        if (!isDesktopHover()) return;
        // short timeout to allow focus moving inside submenu
        scheduleClose(d, 60);
      });
    });

    // Global ESC handler to close all details
    document.addEventListener('keydown', (ev) => {
      if (ev.key === 'Escape') {
        allDetails.forEach((d) => closeDetails(d));
      }
    });

    // When viewport changes (desktop <-> mobile), close all
    const mq = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
    mq.addEventListener('change', () => {
      if (!isDesktopHover()) {
        allDetails.forEach((d) => closeDetails(d));
      }
    });
  }

  // wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
